<script lang="ts" setup>
const props = defineProps<{ date: string | Date | number }>()

const tMsSec = 1000
const tMsMin = 60 * tMsSec
const tMsHour = 60 * tMsMin
const tMsDay = tMsHour * 24

function divide(a: number, b: number): [number, number] {
  return [Math.floor(a / b), a % b]
}

function toStr(days: number, hours: number, minutes: number, secods: number) {
  const daysUi = days ? `${days}d ` : ''
  return daysUi + `${helpers.zeroPad(hours, 2)}:${helpers.zeroPad(minutes, 2)}:${helpers.zeroPad(secods, 2)}`
}

function toTime(date: Date | None, now: Date) {
  if (!date) return '...'
  const totalMs = date.getTime() - now.getTime()
  if (totalMs < 0) return toStr(0, 0, 0, 0)
  const [days, remainder1] = divide(totalMs, tMsDay)
  const [hours, remainder2] = divide(remainder1, tMsHour)
  const [minutes, remainder3] = divide(remainder2, tMsMin)
  const [secods] = divide(remainder3, tMsSec)

  return toStr(days, hours, minutes, secods)
}

function toValue() {
  return toTime(helpers.toDate(props.date), new Date())
}

const time = ref(toValue())
const interval = useInterval('UiCountdown', true)
interval.set(() => {
  const val = toValue()
  if (time.value !== val) time.value = val
}, 1000)
</script>

<template>
  <span>{{ time }}</span>
</template>
